import styled from 'styled-components'
import { Badge } from 'react-bootstrap'

export const ClearBadge = styled(Badge)`
  background-color: #ffffff;
  border: none;
  color: white;
`
